import { render, staticRenderFns } from "./RatingBoard.vue?vue&type=template&id=642787a8&scoped=true&"
import script from "./RatingBoard.vue?vue&type=script&lang=js&"
export * from "./RatingBoard.vue?vue&type=script&lang=js&"
import style0 from "./RatingBoard.vue?vue&type=style&index=0&id=642787a8&lang=less&scoped=true&"
import style1 from "./RatingBoard.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642787a8",
  null
  
)

export default component.exports